import { createSlice } from '@reduxjs/toolkit'

import { mode_type } from '@/theme/types/constants'

import { ThemeModeState } from '../types/CountType'

/* get theme in local after check to initial for mode theme MUI  */
const modeLocal = localStorage.getItem('theme')

let THEME_MODE_INITIAL = mode_type.light
if (modeLocal === mode_type.custom) {
  THEME_MODE_INITIAL = mode_type.custom
}
if (modeLocal === mode_type.dark) {
  THEME_MODE_INITIAL = mode_type.dark
}
if (modeLocal === mode_type.light) {
  THEME_MODE_INITIAL = mode_type.light
}

const initialState: ThemeModeState = {
  themeMode: THEME_MODE_INITIAL,
}

export const themeSlice = createSlice({
  name: 'theme',
  initialState,
  reducers: {
    changeTheme: (state, action) => {
      state.themeMode = action.payload
    },
  },
})

// Action creators are generated for each case reducer function
export const { changeTheme } = themeSlice.actions

export default themeSlice.reducer
